import * as React from "react";
import { Table24Regular, Table24Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const ODLPortalApp = React.lazy(async () => {
    const namedExport = await import("./ODLPortalApp");
    return { default: namedExport.ODLPortalApp };
});

export const ODLPortal: TeamAppConfig = {
    title: "Office Data Loader Portal",
    regularIcon: Table24Regular,
    filledIcon: Table24Filled,
    description:
        "Self-service portal for onboarding and managing Office Data Loader (ODL) log types, nodes, and targets " +
        "across workloads and deployments, including filter configuration, validation, and Kusto Exporter integration.",
    team: "ODL",
    publicId: "EXCHANGE\\ODL",
    owner: "odlteam@microsoft.com",
    role: "*",
    tags: ["ODL", "portal"],
    app: ODLPortalApp,
    path: "/ODL/ODLPortal"
};
